import FormControl from "./FormControl";
import React, {useState, useEffect} from "react";
import useFetchCountries from "../hooks/useFetchCountries";
import useKeyboard from "../hooks/ui/useKeyboard";
import AvatarUpload from "./AvatarUpload";
import {useTranslation} from "react-i18next";

const UpdateProfile = ({avatar, name, email, phone, company = false, companyLabel, location, locationLabel, remarks, remarksHelp, remarksLabel, formik, errors, type=''}) => {
  const {t} = useTranslation('global')
  const {data: countriesData, status: countriesStatus} = useFetchCountries({
    enabled: !!phone,
  });
  const {onFocus, onBlur} = useKeyboard();
  const [image, setImage] = useState(false);

  return (
    <div>
      {avatar && (
        <div>
          <AvatarUpload
            value={formik.values.avatar}
            onChangeImage={image => {
              formik.setFieldValue('avatar', image);
            }}
            disabled={formik.isSubmitting}
            image={image}
            setImage={setImage}
            type={type}
            containerStyle={`w-16 h-16 lg:w-20 lg:h-20`}
            textSize={`text-lg`}
          />
        </div>
      )}
      {(type === 'guest' || !image) && name && (
        <FormControl.Default className="mb-4" inputClass="input-control" htmlFor="name" label={t('name')} error={formik.touched.name && errors.name}>
          <input
            type="text"
            placeholder=" "
            {...formik.getFieldProps('name')}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </FormControl.Default>
      )}
      {(type === 'guest' || !image) && email && (
        <FormControl.Default className="mb-4" inputClass="input-control" htmlFor="email" label={t('email')} error={formik.touched.email && errors.email}>
          <input
            type="email"
            placeholder=" "
            {...formik.getFieldProps('email')}
          />
        </FormControl.Default>
      )}
      {(type === 'guest' || !image) && phone && (
        <FormControl.InlineGroup className="mb-4" error={(formik.touched.phone && errors.phone) || (formik.touched.phone_country && errors.phone_country)}>
          <FormControl.Select
            label={t('extension')}
            className="w-2/6 md:3/6 lg:w-2/6 mr-2"
            options={countriesStatus !== 'success' ? [
              {value: '', label: countriesStatus === 'error' ? 'Error' : 'Loading'}
            ] : countriesData.map(item => ({
              value: item.iso_3166_2,
              label: `${item.name} (+${item.calling_code})`
            }))}
            {...formik.getFieldProps('phone_country')}
          />
          <FormControl.Default className="flex-1" inputClass="input-control" htmlFor="phone" label={t('phone-number')}>
            <input
              type="tel"
              placeholder=" "
              {...formik.getFieldProps('phone')}
            />
          </FormControl.Default>
        </FormControl.InlineGroup>
      )}
      {(type === 'guest' || !image) && location && (
        <FormControl.Select
          className="mb-4"
          htmlFor="location"
          label={locationLabel || t('location')}
          error={formik.touched.location && errors.location}
          options={["Kuala Lumpur","Labuan","Putrajaya","Johor","Kedah","Kelantan","Malacca","Negeri Sembilan","Pahang","Perak","Perlis","Penang","Sabah","Sarawak", "Selangor","Terengganu"].map(item => ({
            value: item,
            label: item,
          }))}
          disabled={formik.isSubmitting}
          {...formik.getFieldProps('location')}
        />
      )}
      {(type === 'guest' || !image) && company && (
        <FormControl.Default
          className="mb-4"
          inputClass="input-control"
          htmlFor="company"
          label={companyLabel || t('school-organisation')}
          error={formik.touched.company && errors.company}
        >
          <input
            type="text"
            placeholder=" "
            disabled={formik.isSubmitting}
            {...formik.getFieldProps('company')}
          />
        </FormControl.Default>
      )}

      {(type === 'guest' || !image) && remarks && (
        <FormControl.Default
          className="mb-4"
          type="text"
          htmlFor="remarks"
          label={remarksLabel || t('remarks')}
          inputClass="textarea"
          error={formik.touched.remarks && errors.remarks}
        >
                            <textarea
                              placeholder=" "
                              rows={4}
                              disabled={formik.isSubmitting}
                              {...formik.getFieldProps('remarks')}
                            />
          {remarksHelp && (
            <p className="text-sm">{remarksHelp}</p>
          )}
        </FormControl.Default>
      )}
    </div>
  );
};

export default UpdateProfile;
